// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import VueI18n from 'vue-i18n';
// 【Custom Plugins】
// Import Cognito Plugins..
// 【Constants】
import texts from '../common/src/constrains/locale/texts';
import vuetify from './plugins/vuetify';
import Vuex from 'vuex'
import RoomInfoModule from './store/modules/RoomInfoModule'
import OfficeInfoModule from './store/modules/OfficeInfoModule'
import LoadingModule from './store/modules/LoadingModule'
import InvokeUrlMaker from './custom_plugins/invoke/url_maker';
import Cognito from './custom_plugins/auth/cognito';
import VueLogger from 'vuejs-logger';
import {extend, ValidationProvider} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
extend('required', required);
extend('roomNo', {
    validate: function (value) {
        return /[0-9０-９]{4}/.test(value)
    }
});


Vue.component('ValidationProvider', ValidationProvider);
Vue.use(Cognito, process.env);
Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(InvokeUrlMaker);

const isProduction = process.env.NODE_ENV !== 'development';
const loggerOptions = {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};
Vue.use(VueLogger, loggerOptions);

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'ja',
    messages: texts
});
Vue.config.productionTip = false;

const store = new Vuex.Store({
    modules: {
        RoomInfoModule,
        OfficeInfoModule,
        LoadingModule
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    i18n: i18n,
    router,
    Cognito,
    store,
    components: {App},
    vuetify,
    template: '<App/>',
    vuex: false,
});



// WEBPACK FOOTER //
// ./src/main.js